import React, { useEffect, useState, useCallback } from "react";
import Layout from "./Layout";
import { db } from "../../../config/firebase";
import { createInitialForm } from "../../../common/common";
import { inventoryPodData } from "../../../assets/lib/vendor";
import { inventoryProductsData } from "../../../assets/lib/inventoryProduts.js";
import { COLLECTION, SESSION } from "../../../data/constant";
import {
  doc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
  setDoc,
  deleteField,
} from "firebase/firestore";

const VendorManageInventory = () => {
  const [vendorId, setVendorId] = useState(null);
  const [podSelected, setPodSelected] = useState(null);
  const [podMenu, setPodMenu] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForProduct, setIsModalOpenForProduct] = useState(false);
  const [inventoryState, setInventoryState] = useState(
    createInitialForm(inventoryPodData)
  );
  const [productState, setProductState] = useState(
    createInitialForm(inventoryProductsData)
  );
  const [productData, setProductData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);

  // Initialize session/vendor/pods
  useEffect(() => {
    const init = async () => {
      const sessionId = localStorage.getItem(SESSION.VENDOR_SESSION_ID);
      if (!sessionId) return;

      const sessionSnap = await getDoc(doc(db, COLLECTION.VENDOR_SESSION, sessionId));
      if (!sessionSnap.exists()) return;

      const vendorId = sessionSnap.data().vendorId;
      setVendorId(vendorId);

      const vendorSnap = await getDoc(doc(db, COLLECTION.VENDOR, vendorId));
      if (!vendorSnap.exists()) return;

      const vendorData = vendorSnap.data();
      setPodMenu(vendorData.podsForVendor || []);
      setProductData(vendorData.vendorProducts || []);
      if (vendorData.podsForVendor?.length > 0) {
        setPodSelected(vendorData.podsForVendor[0]);
      }
    };

    init();
  }, []);

  // Fetch inventory when pod changes
  const refreshInventoryData = useCallback(async () => {
    if (!podSelected) return;
    setIsTableLoading(true);
    const inventorySnap = await getDoc(doc(db, COLLECTION.INVENTORY, podSelected));
    if (inventorySnap.exists()) {
      const data = inventorySnap.data();
      const rows = Object.entries(data).map(([itemId, itemData]) => ({
        ...itemData,
        itemId,
      }));
      setInventoryData(rows);
    } else {
      setInventoryData([]);
    }
    setIsTableLoading(false);
  }, [podSelected]);

  useEffect(() => {
    refreshInventoryData();
  }, [podSelected, refreshInventoryData]);

  const getInputHandler = (setter) => (event) => {
    const { name, value, type } = event.target;
    setter((prev) => ({
      ...prev,
      [name]: type === "number" ? parseInt(value, 10) : value,
    }));
  };

  const getProductInput = getInputHandler(setProductState);
  const getInventoryInput = getInputHandler(setInventoryState);

  const updateModalClicked = (row) => {
    setInventoryState(row);
    setIsModalOpen(true);
  };

  const handleSubmitModal = async () => {
    const { itemId, ...data } = inventoryState;
    if (!itemId) return;
    const ref = doc(db, COLLECTION.INVENTORY, podSelected);
    await updateDoc(ref, { [itemId]: data });
    setIsModalOpen(false);
    setInventoryState(createInitialForm(inventoryPodData));
    refreshInventoryData();
  };

  const handledelete = async (row) => {
    const itemToDelete = inventoryData.find((item) => item.productId === row.productId);
    if (!itemToDelete) return;

    const ref = doc(db, COLLECTION.INVENTORY, podSelected);
    await updateDoc(ref, {
      [itemToDelete.itemId]: deleteField(),
    });

    refreshInventoryData();
  };

  const handleSubmitModalforProducts = async () => {
  const quantity = productState.quantity;
  const selectedProduct = productData.find(
    (p) => p.productId === productState.productId
  );
  if (!selectedProduct) return;

  const totalPrice = selectedProduct.unitPrice * quantity;

  // Calculate expiry date string
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + selectedProduct.expiry);
  const expiryStr = expiryDate.toDateString();

  const newItem = {
    ...selectedProduct,
    ...productState,
    expiry: expiryStr,                      // ✅ Store as string
    unitPrice: totalPrice,
    productName: selectedProduct.productName, // ✅ Store product name too
  };

  const ref = doc(db, COLLECTION.INVENTORY, podSelected);
  const newKey = `item_${Date.now()}`;
  await updateDoc(ref, {
    [newKey]: newItem,
  });

  setProductState(createInitialForm(inventoryProductsData));
  setIsModalOpenForProduct(false);
  refreshInventoryData();
};


  return (
    <Layout
      podMenu={podMenu}
      podSelected={podSelected}
      setPodSelected={setPodSelected}
      itemsData={inventoryData}
      isTableLoading={isTableLoading}
      updateModalClicked={updateModalClicked}
      isModalOpen={isModalOpen}
      inventoryState={inventoryState}
      setIsModalOpen={setIsModalOpen}
      handleSubmitModal={handleSubmitModal}
      getInventoryInput={getInventoryInput}
      isModalOpenForProduct={isModalOpenForProduct}
      setIsModalOpenForProduct={setIsModalOpenForProduct}
      productState={productState}
      handleSubmitModalforProducts={handleSubmitModalforProducts}
      getProductInput={getProductInput}
      productMenu={[]} // not used anymore
      setProductMenu={() => {}} // no-op to preserve Layout props
      productData={productData}
      handledelete={handledelete}
    />
  );
};

export default VendorManageInventory;
